import React from 'react'
import PropTypes from 'prop-types'

function Community({ styling }) {
  return (
    <svg
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className={styling}
    >
      <path d="M50.84 28.23h7.74l2.16 5.61h2.79l-7.58-18.51h-2.64L46.2 33.84h2.6l2.04-5.61zm2.74-7.42c.43-1.17.76-2.35 1-3.54.29 1 .72 2.28 1.31 3.84l1.93 5.13h-6.28l2.04-5.43zM24.22 92.5h41.82c2.58 0 4.67-2.1 4.67-4.67V63c0-2.58-2.1-4.67-4.67-4.67H48.87c-.47 0-.86-.39-.86-.86v-9.03c0-.65-.39-1.23-.98-1.47-.6-.25-1.28-.11-1.74.35l-10.3 10.29c-.47.47-1.08.72-1.74.72h-9.03c-2.58 0-4.67 2.1-4.67 4.67v24.83c0 2.57 2.1 4.67 4.67 4.67zM21.76 63c0-1.36 1.1-2.46 2.46-2.46h9.03c1.25 0 2.42-.49 3.3-1.37l9.25-9.25v7.55c0 1.69 1.38 3.07 3.07 3.07h17.18c1.36 0 2.46 1.1 2.46 2.46v24.83c0 1.36-1.1 2.46-2.46 2.46H24.22c-1.36 0-2.46-1.1-2.46-2.46V63z" />
      <path d="M33.95 41.67h17.18c.47 0 .86.39.86.86v9.03a1.583 1.583 0 001.59 1.59c.41 0 .82-.16 1.13-.47L65 42.39c.47-.47 1.08-.72 1.74-.72h9.03c2.58 0 4.67-2.1 4.67-4.67V12.17c0-2.58-2.1-4.67-4.67-4.67H33.95c-2.58 0-4.67 2.1-4.67 4.67V37c0 2.57 2.1 4.67 4.67 4.67zm-2.46-29.5c0-1.36 1.1-2.46 2.46-2.46h41.83c1.36 0 2.46 1.1 2.46 2.46V37c0 1.36-1.1 2.46-2.46 2.46h-9.03c-1.25 0-2.42.49-3.3 1.37l-9.25 9.25v-7.55c0-1.69-1.38-3.07-3.07-3.07H33.95c-1.36 0-2.46-1.1-2.46-2.46V12.17z" />
    </svg>
  )
}
// PROPTYPES
const { string } = PropTypes
Community.propTypes = {
  styling: string,
}

export default Community
